import { isNumber, isObject, isString } from 'typechecker'
import Score from '@/interfaces/Score'

/** 評論 */
export default class Comment {
  /** 客戶名稱 */
  name?: string
  /** 客戶的地點 */
  country?: string
  /** 訂單的日期時間 */
  startDate?: string
  /** 評論的日期時間 */
  commentDate?: string
  /** 評論內容 */
  content?: string
  /** 評論細項分數 */
  score: Score = {}
  /** 評論分數 */
  averageScore?: number
  /** 車型 */
  product?: string

  /** 商家回覆 */
  storeReply?: string
  /** 商家回覆 */
  storeReplyDate?: string

  constructor (comment: {
    /* eslint-disable camelcase */
    customer_name: string,
    car: string,
    start_time: string,
    country_name: string,
    store_score_all?: number,
    store_score_service?: number,
    store_score_manner?: number,
    store_score_clean?: number,
    store_comment?: string | null,
    customer_filled: string,
    score_float?: number,
    store_reply?: string | null,
    replied_at?: string | null,
    /* eslint-disable camelcase */
  }) {
    if (!isObject(comment)) throw new TypeError('`comment` must be an object!')

    if (isString(comment.customer_name)) this.name = comment.customer_name
    if (isString(comment.country_name)) this.country = comment.country_name
    if (isString(comment.start_time)) this.startDate = comment.start_time
    if (isString(comment.customer_filled)) this.commentDate = comment.customer_filled
    if (comment.store_comment && isString(comment.store_comment)) this.content = comment.store_comment
    if (isNumber(comment.store_score_all)) this.score.all = comment.store_score_all
    if (isNumber(comment.store_score_service)) this.score.service = comment.store_score_service
    if (isNumber(comment.store_score_manner)) this.score.manner = comment.store_score_manner
    if (isNumber(comment.store_score_clean)) this.score.clean = comment.store_score_clean
    if (isNumber(comment.score_float)) this.averageScore = comment.score_float
    if (isString(comment.car)) this.product = comment.car
    if (comment.store_reply && isString(comment.store_reply)) this.storeReply = comment.store_reply
    if (comment.replied_at && isString(comment.replied_at)) this.storeReplyDate = comment.replied_at
  }
}
